// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a5f7067e","453":"6616c70a","732":"8e0365f5","977":"0b7204d1"}[chunkId] + ".chunk.js";
};